import React from 'react';
import {Plan} from '../types/Plan';
import {getFormattedNumber} from '../utils/NumberUtils';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretDown, faCaretUp} from '@fortawesome/free-solid-svg-icons';
import {PlanVO} from '../api';

interface SouhrnDetailProps {
    plan: Plan | PlanVO;
    skutecnost: boolean;
}

export const SouhrnDetail: React.FC<SouhrnDetailProps> = ({plan, skutecnost}) => {
    if (
        plan.schvalenyRozpocet === undefined ||
        plan.upravenyRozpocet === undefined ||
        plan.skutecnnost === undefined ||
        plan.rozdil === undefined ||
        plan.procento === undefined
    ) {
        return null;
    }

    const diffLabel = plan.schvalenyRozpocet < plan.upravenyRozpocet ? 'navýšeno' : 'poníženo';

    if (skutecnost) {
        const procenta = Math.round((plan.skutecnnost / plan.upravenyRozpocet) * 100);
        const rozdil = plan.upravenyRozpocet - plan.skutecnnost;

        return (
            <div>
                <h2>{plan.nazevAkce}</h2>
                <div className="bigger-text">{getFormattedNumber(plan.skutecnnost)} tis. Kč</div>
                <div>
                    Vydáno {procenta}% z upraveného rozpočtu (zbývá {getFormattedNumber(rozdil)} tis. Kč).
                </div>
            </div>
        );
    }

    let icon;
    if (plan.rozdil < 0) {
        icon = <FontAwesomeIcon icon={faCaretDown} style={{marginRight: 8}} />;
    } else if (plan.rozdil > 0) {
        icon = <FontAwesomeIcon icon={faCaretUp} style={{marginRight: 8}} />;
    }

    return (
        <div>
            <h2>{plan.nazevAkce}</h2>
            <div className="bigger-text">
                {icon}
                {getFormattedNumber(plan.upravenyRozpocet)} tis. Kč
            </div>
            {plan.rozdil === 0 ? (
                <div>Plánovaný výdaj nebyl změněn.</div>
            ) : (
                <div>
                    Plánovaný výdaj upraven o {plan.procento * 100}% proti schválenému rozpočtu ({diffLabel} o {getFormattedNumber(Math.abs(plan.rozdil))} tis.
                    Kč).
                </div>
            )}
        </div>
    );
};
